
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import SvgImgV3 from "@/components/videoPaly/video-play-v3.vue";
import {
  AI,
  Answer,
  AIGroup,
  Candidate,
  CandidateResult,
  ColorQuestionAnswerResult,
  FingerCheckResult,
  ReportShowConfigV5Item
} from "@/lib/model/exam/result";
import ResultTs from "../result-ai-report";

enum cheatEnum {
  "finger" = "手部综合检测"
}

const cheatKeys = ["finger"];

//异常项 默认文案
const errorEnumText = ["未检测", "未通过", "通过"];

//手部
enum enumFinger {
  "未按要求拍摄" = 0,
  "通过" = 1,
  "有异常" = 2,
  "考察项未配置" = 255
}

@Component({
  components: { SvgImgV3 }
})
export default class PaperResultReport extends Vue {
  @Prop() index!: number;
  @Prop({ default: () => new Candidate() }) candidate!: Candidate;
  @Prop({ default: () => new CandidateResult() }) all!: CandidateResult;
  @Prop({ default: false }) pdfIng!: boolean;
  @Prop({ default: () => new ReportShowConfigV5Item() })
  option!: ReportShowConfigV5Item;
  connectCode = "";
  fingerList: any = [];

  @Watch("all")
  getAll(nval: CandidateResult) {
    this.getFingerList();
  }

  //手指检测109
  get finger() {
    return (
      this.all?.questionAnswerMap?.[109]?.[0]?.answer?.fingerCheckResult ||
      new FingerCheckResult()
    );
  }

  // 已配置项数 ？？
  // get fingerNum() {
  //   return [
  //     this.finger.resultFlexible !== 255,
  //     this.finger.resultComplete !== 255,
  //     this.finger.resultScar !== 255
  //   ].filter(item => item).length;
  // }

  created() {
    //
    // this.getCheatList()
  }

  //
  mounted() {
    this.getFingerList();
    // this.connectCode = this.$route.query.connectCode as string;
    // this.isStudent = String(this.$route.query.ver || "") === "1";
    document.addEventListener("fullscreenchange", this.checkFullscreen);
  }
  beforeDestroy() {
    document.removeEventListener("fullscreenchange", this.checkFullscreen);
  }
  //全屏视频修改填充样式
  isVideoFullscreen = false;
  scrollPosition = 0;
  get objectFit() {
    return this.isVideoFullscreen ? "contain" : "cover";
  }
  checkFullscreen() {
    this.isVideoFullscreen =
      document.fullscreenElement !== null &&
      document.fullscreenElement.tagName === "VIDEO";
    // try {
    //   if (document.fullscreenElement) {
    //     this.scrollPosition =
    //       window.scrollY || document.documentElement.scrollTop;
    //   }
    //   if (!document.fullscreenElement) {
    //     window.scrollTo(0, this.scrollPosition);
    //   }
    // } catch (e) {
    //   console.log(e);
    // }
  }

  fingerResText(i: number) {
    return enumFinger[i];
  }

  fingerText(i: number) {
    return ["未检测", "通过", "未通过"][i];
  }

  openImg(url: string) {
    this.$emit("openImg", url);
  }

  getFingerList() {
    this.fingerList = [];
    this.all.errorInfoList.forEach(item => {
      if (cheatKeys.includes(item.task)) {
        this.fingerList.push({
          name: cheatEnum[item.task],
          type: item.result,
          task: item.task,
          result: errorEnumText[item.result],
          value: item.resMessage || errorEnumText[item.result]
        });
      }
    });
  }

  async wait(secends: number) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(true);
      }, secends);
    });
  }
}
